import { render, staticRenderFns } from "./file-preview.vue?vue&type=template&id=e61f2f6a&scoped=true"
import script from "./file-preview.vue?vue&type=script&lang=js"
export * from "./file-preview.vue?vue&type=script&lang=js"
import style0 from "./file-preview.vue?vue&type=style&index=0&id=e61f2f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61f2f6a",
  null
  
)

export default component.exports